export const SERVICE_FIELD_KEYS = [
    'name',
    'billedUpon',
    'recurrence',
    'pricingType',
    'automaticState',
    'completionState',
    'cap',
    'priceMin',
    'priceMax',
    'discount.type',
    'discount.amount',
    'discount.expiration',
    'priceIncrease.exists',
    'priceIncrease.percent',
    'priceIncrease.startOnType',
    'priceIncrease.startOn',
    'limitedTimeDiscountOffer',
    'maxCharges',
    'billUpfront',
    'isBundle',
    'description',
    'startBillingAt'
];
export const SERVICE_CHIP_FIELDS = [
    'name',
    'recurrence',
    'billedUpon',
    'priceMin',
    'priceMax',
    'billingOccurrence',
    'billingTrigger',
    'automaticState',
    'completionState',
    'pricingType',
    'servicePrice',
    'capExists',
    'cap',
    'discountType',
    'discountAmount',
    'discountExpiration',
    'discountExpirationDate',
    'priceIncreasePercent',
    'priceIncreaseStartOnType',
    'priceIncreaseStartOn',
    'priceIncreaseExists',
    'limitedTimeDiscountOffer',
    'maxChargesExists',
    'maxChargesLimit',
    'billUpfront',
    'description',
    'startBillingAtExists',
    'startBillingAtDate'
];
export const isServiceChipField = (value)=>value != null && SERVICE_CHIP_FIELDS.includes(value);
export const toEntityCollection = (grammar, collection)=>{
    if (collection == null) return undefined;
    const entity = {};
    for (const quantifier of Object.keys(collection)){
        const predicate = collection[quantifier];
        if (predicate != null) entity[quantifier] = grammar.toEntityPredicate(predicate);
    }
    return entity;
};
